// Employer Api
export const employerBaseUrlApi = 'job-fair-management/employers/'
export const employerRegistrationListApi = employerBaseUrlApi + 'list'
export const employerRegistrationStoreApi = employerBaseUrlApi + 'store'
export const employerRegistrationUpdateApi = employerBaseUrlApi + 'update'
export const employerRecommendedListApi = employerBaseUrlApi + 'forwarded-list'
export const employerApprovedListApi = employerBaseUrlApi + 'approved-list'
export const employerForwardApi = employerBaseUrlApi + 'forward'
export const employerApproveApi = employerBaseUrlApi + 'approve'
export const employerRejectApi = employerBaseUrlApi + 'reject'

// Applicant List
const applicant = 'job-fair-management/applicants/'
export const applicantList = applicant + 'list'
export const applicantShow = applicant + 'show'
export const applicantToggleStatus = applicant + 'toggle-status'
const confirmationList = 'employer-panel/confirm_list/'
export const confirmationListData = confirmationList + 'confirm_data'

// Job fair circulation Api
export const jobFairCirculationBaseUrlApi = 'job-fair-management/job-fair-circulations/'
export const jobFairCirculationListApi = jobFairCirculationBaseUrlApi + 'list'
export const jobFairCirculationStoreApi = jobFairCirculationBaseUrlApi + 'store'
export const jobFairCirculationShowApi = jobFairCirculationBaseUrlApi + 'show'
export const jobFairCirculationUpdateApi = jobFairCirculationBaseUrlApi + 'update'
export const jobFairCirculationToggleStatusApi = jobFairCirculationBaseUrlApi + 'toggle-status'
export const empCvReportApi = 'job-fair-management/reports/emp-wise-cv'

// Sorting Application Api
export const sortingApplicationBaseUrlApi = 'job-fair-management/sorting-application/'
export const sortingApplicationCircularApi = sortingApplicationBaseUrlApi + 'get-circular'
export const circularApplicationApi = sortingApplicationBaseUrlApi + 'application-data'
export const sortingApplicationListApi = sortingApplicationBaseUrlApi + 'list'
export const sortingApplicationStoreApi = sortingApplicationBaseUrlApi + 'store'
export const sortingApplicationShowApi = sortingApplicationBaseUrlApi + 'show'
export const sortingApplicationUpdateApi = sortingApplicationBaseUrlApi + 'update'
export const employerDataApi = sortingApplicationBaseUrlApi + 'employer-data'
export const deleteSorting = sortingApplicationBaseUrlApi + 'destroy'

// Job Confirmation List
export const jobConfirmationApi = 'job-fair-management/confirmation-list/list'

// Circular Wise CV Report
export const circularWiseCVReportApi = 'job-fair-management/reports/circular-wise-cv-report'
export const reportHeadingList = '/configuration/report-heading/detail'

// CV View
export const resumeViewApi = 'job-fair-management/cv/view'

// Direct Apply for Job api
const directApplyForJobBaseUrl = 'job-fair-management/direct-apply-for-job/'
export const directApplyForJobBaseUrlPatientList = directApplyForJobBaseUrl + 'patient-list'
export const directApplyForJobBaseUrlStore = directApplyForJobBaseUrl + 'store'
// Cv Bank Route
export const storePersonalInfoApi = 'job-fair-management/cv-bank/store-personal-info'
export const storeQualificationApi = 'job-fair-management/cv-bank/store-qualification'
export const updateQualificationApi = 'job-fair-management/cv-bank/update-qualification'
export const storeEmploymentApi = 'job-fair-management/cv-bank/store-employment'
export const updateEmploymentApi = 'job-fair-management/cv-bank/update-employment'
export const patientCvBankListApi = 'job-fair-management/cv-bank/list'
export const patientCvBankUpdateDataApi = 'job-fair-management/cv-bank/updatedata'
export const CvBankresumeViewApi = 'job-fair-management/cv-bank/resumeview'
export const CvBankprofileUpdate = 'job-fair-management/cv-bank/profileupdate'
// job confirmation report routes
export const jobConfirmationReportApi = 'job-fair-management/reports/job-confirmation-report'
